// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1917":"7135ab04","2668":"4f8f2833","6671":"023bbba5"}[chunkId] + ".chunk.css";
};